"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ToastProvider_container_1 = __importDefault(require("./ToastProvider.container"));
exports.default = ToastProvider_container_1.default;
//# sourceMappingURL=index.js.map